import React, { useState } from "react";
import Intermediat_Check_Form from "./intermediat_Check_Form/Intermediat_Check_Form";
import Intermediat_Check_table from "./intermediat_Check_table/Intermediat_Check_table";

function Intermediat_Check() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Intermediat_Check_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Intermediat_Check_table />
        </div>
      )}
    </>
  );
}

export default Intermediat_Check;
